<div class="modal-header">
    <h3 class="modal-title">Move to Batch</h3>
</div>

<div class="modal-body">
    <div class="row" *ngIf="alert">
        <div class="col-12">
            <div class="alert" [ngClass]="{'alert-success' : alert.type === 'success', 'alert-default' : alert.type === 'default', 'alert-danger': alert.type === 'danger' }" role="alert">
                {{alert.msg}}
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6" style="margin-top:15px; padding-left:30px;">
            <div style="margin-bottom:5px;"><b>Total # of Receipts Selected</b>: {{approvedCount+unApprovedCount}}</div>
            <div style="margin-bottom:5px;"><b>Total Cost of Receipts Selected</b>: {{sum|currency:currencySymbol}}</div>
            <div style="margin-bottom:5px;"><b># of Approved Receipts</b>: {{approvedCount}}</div>
            <div style="margin-bottom:5px;"><b># of Unapproved Receipts</b>: {{unApprovedCount}}</div>
        </div>
        <div class="col-lg-6">
            <div *ngIf="unApprovedCount > 0" class="alert alert-warning" role="alert">
                You have selected receipts that are not approved. If you process these receipts, the manager(s) of the
                unapproved employees will not be notified.
            </div>

            <div *ngIf="approvedCount+unApprovedCount == approvedCount" class="alert alert-success" role="alert">
                All selected receipts have been approved and are ready for processing!
            </div>
        </div>
    </div>

    <div *ngIf="ProcessType === 'P' || ProcessType === 'B'">
        <div class="card border mt-3">
            <div class="card-header bg-light">
                <h3 class="card-title">Process Expenses via Payroll</h3>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12" style="margin-bottom:10px;">
                        This process will create a new timecard batch for the pay period and pay sequence selected
                        below. Expense receipts selected will be moved to the batch for subsequent validation and
                        processing in Vista.
                    </div>
                    <div class="col-lg-6">
                        <label><strong>Pay Period</strong></label>
                        <ng-select [(ngModel)]="formData.SelectedPayPeriod" name="PayPeriod"
                                   [items]="payPeriodList" [ngClass]="{'is-invalid' : formData.SelectedPayPeriod == null}"
                                   (change)="getPaySeq()" bindLabel="PREndDateDisplay"
                                   [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                        </ng-select>
                    </div>
                    <div class="col-lg-6">
                        <label><strong>Pay Seq</strong></label>
                        <ng-select [(ngModel)]="formData.SelectedPaySeq" name="PaySeq"
                                   [ngClass]="{'is-invalid' : formData.SelectedPaySeq == null}" [items]="paySeqList"
                                   bindLabel="SeqDescription" bindValue="PaySeq"
                                   [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                        </ng-select>
                    </div>
                </div>
                <div class="row" style="margin-top:10px;">
                    <div class="col-lg-8">
                        <label><strong>Earn Code</strong></label>
                        <ng-select [(ngModel)]="formData.SelectedEarnCode" name="EarnCode"
                                   [items]="earnCodeList" bindLabel="DisplayName" bindValue="EarnCode"
                                   [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                        </ng-select>
                    </div>
                    <div class="col-lg-6">
                        <button class="btn btn-success buttonNoLabel" type="button" (click)="processClicked('P')"
                                *ngIf="ProcessType === 'P' || ProcessType === 'B'"
                                [disabled]="formData.SelectedPayPeriod == null || formData.SelectedPaySeq == null">
                            Move to
                            PR Batch
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="ProcessType === 'A' || ProcessType === 'B'">
        <div class="card border mt-3">
            <div class="card-header bg-light">
                <h3 class="card-title">Process Expenses via AP</h3>
            </div>
            <div class="card-body">
                <div class="col-lg-12" style="margin-bottom:10px;">
                    This process will create a new AP transaction batch for subsequent validation and processing in
                    Vista. Expense receipts selected will be moved to the batch as individual invoices for each submitted
                    expense package.
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        <div>
                            <label><strong>Batch Month:</strong></label>
                            <div class="input-group">
                                <input type="text" class="form-control" bsDatepicker #monthdp="bsDatepicker"
                                       [(ngModel)]="formData.selectedMonth" [outsideClick]="true" name="BatchMonth"
                                       [bsConfig]="datePickerOptionsMonth" style="background-color:#ffffff"
                                       (onShown)="onOpenCalendar($event)">
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-secondary" (click)="monthdp.show()"
                                            [attr.aria-expanded]="monthdp.isOpen" style="margin-right:0px">
                                        <i class="modus-icons align-bottom">calendar</i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4" *ngIf="exAddAPReftoPosting">
                        <div>
                            <label><strong>AP Reference #:</strong></label>
                            <div class="input-group">
                                <input type="text" class="form-control" [(ngModel)]="formData.aPRef" maxlength="12"
                                       style="background-color:#ffffff;" />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <button class="btn btn-success" type="button" (click)="processClicked('A')"
                                style="margin-top:25px;">
                            Move to AP Batch
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="ProcessType === 'C'">
        <div class="card border mt-3">
            <div class="card-header">
                <h3 class="card-title">Process Credit Card Transactions</h3>
            </div>
            <div class="card-body">
                <div class="col-lg-12" style="margin-bottom:10px;">
                    This process will create a new AP transaction batch for subsequent validation and processing in
                    Vista. A single invoice will be created with the each expense receipt as a detail line.
                </div>
                <div class="row col-lg-12">
                    <div class="col-lg-4">
                        <div>
                            <label><strong>Batch Month:</strong></label>
                            <div class="input-group">
                                <input type="text" class="form-control" bsDatepicker #monthdp="bsDatepicker"
                                       [(ngModel)]="formData.selectedMonth" [outsideClick]="true" name="BatchMonth"
                                       [bsConfig]="datePickerOptionsMonth" style="background-color:#ffffff"
                                       (onShown)="onOpenCalendar($event)">
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-secondary" (click)="monthdp.show()"
                                            [attr.aria-expanded]="monthdp.isOpen" style="margin-right:0px">
                                        <i class="modus-icons align-bottom">calendar</i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4" *ngIf="exAddAPReftoPosting">
                        <div>
                            <label><strong>AP Reference #:</strong></label>
                            <div class="input-group">
                                <input type="text" class="form-control" [(ngModel)]="formData.aPRef" maxlength="12"
                                       style="background-color:#ffffff;" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row col-lg-12">
                    <div class="col-lg-6" *ngIf="vendorList?.length > 0">
                        <label><strong>CC Vendor</strong></label>
                        <ng-select [(ngModel)]="formData.SelectedVendor" name="CCVendor"
                                   [items]="vendorList" bindLabel="DisplayName" bindValue="KeyID"
                                   [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                        </ng-select>
                    </div>
                    <div class="col-lg-2">
                        <button class="btn btn-success" type="button" (click)="processClicked('E')"
                                style="margin-top:25px;">
                            Move to AP Batch
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>